import { CareerPath, CareerCategory } from '@backrs_ui/common-ui';

import { SxProps, Theme, Dialog } from '@mui/material';

import { WhatIsACareerPathModalContent } from './WhatIsACareerPathModalContent';

type WhatIsACareerPathModalProps = Readonly<{
  open: boolean;
  onClose: () => void;
  careerPaths: CareerPath[];
  careerCategories: CareerCategory[];
}>;

export function WhatIsACareerPathModal({
  open,
  onClose,
  careerPaths,
  careerCategories,
}: WhatIsACareerPathModalProps) {
  return (
    <Dialog
      id="what-is-a-career-path-modal"
      className="what-is-a-career-path-dialog"
      open={open}
      onClose={onClose}
      sx={dialogSx}
    >
      <WhatIsACareerPathModalContent
        onClose={onClose}
        careerPaths={careerPaths}
        careerCategories={careerCategories}
      />
    </Dialog>
  );
}

const dialogSx: SxProps<Theme> = ({ backrs }) => ({
  '& .MuiDialog-paper': {
    width: '95vw',
    maxWidth: '1098px',
    maxHeight: '95vh',
    borderRadius: backrs.radius['radius-lg'],
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'clip',
  },
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});
